const state = {
    isRequesting: false,
    subscriptions: [],
}
export default state